import { FC, ReactNode } from 'react';
import { PunchupInput } from 'features/common/components/Punchup/primitives/forms/fields/PunchupInput';
import styles from './PunchupPersonEntry.module.css';

export interface PunchupPersonEntryProps {
	/** react-hook-form field name for the email input */
	emailName: string;
	/** react-hook-form field name for the first name input */
	firstNameName: string;
	/** react-hook-form field name for the last name input */
	lastNameName: string;
	/** Label shown above the email field. Defaults to "Attendee Email". */
	emailLabel?: string;
	/** Label shown above the first name field. Defaults to "First Name". */
	firstNameLabel?: string;
	/** Label shown above the last name field. Defaults to "Last Name". */
	lastNameLabel?: string;
	/** When true, email field is marked as required (asterisk on label). Defaults to true. */
	emailRequired?: boolean;
	/** Error message displayed below the email field. */
	emailError?: string;
	/** When true, the email input is hidden (e.g. a "recipient has no email" toggle is on). Default false. */
	hideEmail?: boolean;
	/** Optional content rendered directly under the email field — e.g. a "recipient has no email" toggle. */
	belowEmail?: ReactNode;
	/** Optional content rendered below the name row (e.g. PunchupQuantityCard). */
	children?: ReactNode;
}

export const PunchupPersonEntry: FC<PunchupPersonEntryProps> = ({
	emailName,
	firstNameName,
	lastNameName,
	emailLabel = 'Attendee Email',
	firstNameLabel = 'First Name',
	lastNameLabel = 'Last Name',
	emailRequired = true,
	emailError,
	hideEmail = false,
	belowEmail,
	children,
}) => (
	<div className={styles.card}>
		{!hideEmail && (
			<PunchupInput
				label={emailLabel}
				name={emailName}
				id={emailName}
				required={emailRequired}
				errorProp={emailError}
			/>
		)}
		{belowEmail}
		<div className={styles.nameRow}>
			<PunchupInput label={firstNameLabel} name={firstNameName} id={firstNameName} />
			<PunchupInput label={lastNameLabel} name={lastNameName} id={lastNameName} />
		</div>
		{children}
	</div>
);
